<template>
  <div>
    <div class="row">
      <div class="common-sticky-table">
        <b-table class="datatables text-nowrap"
                 hover show-empty
                 tbody-class="border"
                 responsive sticky-header="70vh" no-border-collapse
                 selectable select-mode="single" selected-variant="secondary"
                 :fields="fields" :items="items"
                 @row-selected="onRowSelected"
                 @row-dblclicked="onClickUpdate">

          <template #thead-top>
            <b-tr>
              <b-th colspan="3" class="head-border-rl"></b-th>

              <b-th colspan="3" class="head-border-r">
                <span>봄/가을 </span>
                <b-button id="tooltip-1" variant="transparent" class="p-0">
                  <i class="bx bxs-info-circle align-middle"/>
                </b-button>
                <b-tooltip target="tooltip-1">
                  <pre class="pre-tag-tooltip">{{ seasonTimeSF }}</pre>
                </b-tooltip>
              </b-th>

              <b-th colspan="3" class="head-border-r">
                <span>여름 </span>
                <b-button id="tooltip-2" variant="transparent" class="p-0">
                  <i class="bx bxs-info-circle align-middle"/>
                </b-button>
                <b-tooltip target="tooltip-2">
                  <pre class="pre-tag-tooltip">{{ seasonTimeSm }}</pre>
                </b-tooltip>
              </b-th>

              <b-th colspan="3" class="head-border-r">
                <span>겨울 </span>
                <b-button id="tooltip-3" variant="transparent" class="p-0">
                  <i class="bx bxs-info-circle align-middle"/>
                </b-button>
                <b-tooltip target="tooltip-3">
                  <pre class="pre-tag-tooltip">{{ seasonTimeWt }}</pre>
                </b-tooltip>
              </b-th>

              <b-th colspan="2" class="head-border-r">완속 기타</b-th>
              <b-th colspan="5" class="head-border-r">급속/초급속</b-th>
              <b-th class="head-border-r">비회원</b-th>
            </b-tr>
          </template>

          <template #head(comCode)="data">
            {{ `${data.label} (${items.length})` }}
          </template>

        </b-table>
      </div>
    </div>

    <div class="row pt-4">
      <div class="manage-btns-container">
        <b-button variant="outline-deep-green" class="me-3" :disabled="!tempSelectRow" @click="onClickUpdate(tempSelectRow)">수정
        </b-button>
        <b-button variant="outline-deep-green" class="me-3" :disabled="!tempSelectRow" @click="onClickDelete">삭제</b-button>
        <b-button variant="outline-deep-green" @click="$emit('change-mode','create')">등록</b-button>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: "ManageFeeSeason",
  props: {
    mode: String,
    selectedRow: Object,
  },
  data() {
    const _api = this.$_app.service.comPriceSeason;

    return {
      jqlApi: _api,
      fields: [
        { key: 'comCode', label: `충전사업자`, formatter: val => this.$_app.code.busiId[val], sortable: true, sortByFormatted: true, thClass: 'inset-border-right inset-border-rl'  },
        { key: 'priceType', label: '장소구분', formatter: val => this.$_app.code.priceType[val], sortable: true, sortByFormatted: true, thClass: 'inset-border-r'  },
        { key: 'priceChangeDate', label: '요금 변경일', formatter: val => this.$moment(val).format('YYYY/MM/DD'), sortable: true, sortByFormatted: true, thClass: 'inset-border-r'  },
        { key: 'sfAcPrice.light', label: '경부하', sortable: true },
        { key: 'sfAcPrice.heavy', label: '중부하', sortable: true },
        { key: 'sfAcPrice.max', label: '최대부하', sortable: true, thClass: 'inset-border-r' },
        { key: 'smAcPrice.light', label: '경부하', sortable: true },
        { key: 'smAcPrice.heavy', label: '중부하', sortable: true },
        { key: 'smAcPrice.max', label: '최대부하', sortable: true, thClass: 'inset-border-r' },
        { key: 'wtAcPrice.light', label: '경부하', sortable: true },
        { key: 'wtAcPrice.heavy', label: '중부하', sortable: true },
        { key: 'wtAcPrice.max', label: '최대부하', sortable: true, thClass: 'inset-border-r' },
        { key: 'etcAcPrice3p5', label: '3.5kW', formatter: (val,key,item) => item.etcAcPrice[3.5], sortable: true,sortByFormatted: true },
        { key: 'etcAcPrice.11', label: '11kW', sortable: true, thClass: 'inset-border-r' },
        { key: 'dcPrice.25~30', label: '25~30kW', sortable: true },
        { key: 'dcPrice.50', label: '50kW', sortable: true },
        { key: 'dcPrice.100', label: '100kW', sortable: true },
        { key: 'dcPrice.150', label: '150kW', sortable: true },
        { key: 'highPowerPrice', label: '350kW', sortable: true, thClass: 'inset-border-r' },
        { key: 'nonMemberPrice', label: '완/급', sortable: true, thClass: 'inset-border-r' },
      ],
      items: [],
      show: false,
      deleteAlert: false,
      tempSelectRow: null,
      seasonTimeSF: '',
      seasonTimeSm: '',
      seasonTimeWt: '',
    }
  },
  mounted() {
    const vm = this;

    vm.getCompanyChargingPriceList();

    vm.seasonTimeSF =
      `[ 3~5월, 9~10월 ]
경부하 :      22:00 ~ 08:00
중부하 :      08:00 ~ 11:00
                12:00 ~ 13:00
                18:00 ~ 22:00
최대부하 :   11:00 ~ 12:00
                13:00 ~ 18:00`;
    vm.seasonTimeSm =
      `[ 6~8월 ]
경부하 :      22:00 ~ 08:00
중부하 :      08:00 ~ 11:00
                12:00 ~ 13:00
                18:00 ~ 22:00
최대부하 :   11:00 ~ 12:00
                13:00 ~ 18:00`;
    vm.seasonTimeWt =
      `[ 11월~2월 ]
경부하 :      22:00 ~ 08:00
중부하 :      08:00 ~ 09:00
                12:00 ~ 16:00
                19:00 ~ 22:00
최대부하 :   09:00 ~ 12:00
                16:00 ~ 19:00`;
  },
  methods: {
    getCompanyChargingPriceList() {
      const vm = this;

      vm.jqlApi.list()
        .then(res => {
          vm.items = res;
          console.log(res)
        }).catch(err => {
        console.log(err)
      })

    },
    onRowSelected(row) {
      const vm = this;

      vm.tempSelectRow = row[0];
      console.log('select: ',vm.tempSelectRow);
    },
    onClickUpdate(row) {
      this.$emit('change-mode','update');
      this.$emit('select-row', row);
    },
    onClickDelete() {
      const vm = this;

      this.$swal({
        title: '삭제하시겠습니까?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '확인',
        cancelButtonText: '취소',
      }).then (result => {
        if (result.isConfirmed) {

          vm.delete();
        }
      });
    },
    delete() {
      const vm = this;

      vm.jqlApi.deleteByIdList(vm.tempSelectRow.id)
        .then(res => {
          console.log(res)
          vm.$swal('삭제 완료', '성공적으로 삭제되었습니다.', 'success')
          vm.getCompanyChargingPriceList();
        })
    }
  },
}
</script>